import React from 'react'
import NodeRecord from '../components/NodeRecord'
import { Empty } from 'antd'
import NoData from './../components/NoData'

const NodeRecordComponent = props => {
  const { consumerNode, limit } = props

  return (
    <> 
      { consumerNode ? <NodeRecord id={consumerNode&&consumerNode.id} limit={ limit } /> : <NoData />//<Empty image={require('./../icon/homeIcon/noData.png')} /> 
      }
    </> 
  )
}

const paramSchema = () => ({
  type: 'object',
  properties: {
    limit: {
      type: 'string',
      title: '每页条数'
    }
  },
  form: [ '*' ]
})

const NodeRecordWidget = {
  title: '资产记录',
  category: '页面元素',
  icon: require('../icon/资产记录.svg'),
  paramSchema,
  component: NodeRecordComponent
}

export default NodeRecordWidget
